<template>

    <el-card class="box-card" style="height:590px;">
        <div class="linetab">
            <el-tabs v-model="activeName" @tab-click="handleTableClick">
                <!--<el-tab-pane label="事件" name="first" lazy> Lazy解决tab-pane中echarts宽度错误问题-->
                <el-tab-pane label="事件" name="first">
                    <el-row>
                        <ticket-level-num-statistics :dcnumids="dcnumids" :dcnumMap="dcnumMap"
                                                     :searchDate="searchDate" astyle="height:240px;width:100%;"
                                                     :key="tabKey"></ticket-level-num-statistics>
                        <el-col :span="24" style="margin-top:-30px;">
                            <ticket-on-time-statistics :dcnumids="dcnumids" :dcnumMap="dcnumMap"
                                                       :searchDate="searchDate"></ticket-on-time-statistics>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="问题" name="second">
                    <el-row>
                        <problem-completion-rate :dcnumMap="dcnumMap" :dcnumids="dcnumids"
                                                 :searchDate="searchDate" height="480px"></problem-completion-rate>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="变更" name="third">
                    <el-row>
                        <change-level-num-statistics :dcnumMap="dcnumMap" :dcnumids="dcnumids"
                                                     :searchDate="searchDate" astyle="height:240px;width:100%;"
                                                     :key="tabKey"></change-level-num-statistics>
                        <el-col :span="24" style="margin-top:-30px;">
                            <change-done-statistics :dcnumids="dcnumids" :dcnumMap="dcnumMap"
                                                    :searchDate="searchDate" height="300px"></change-done-statistics>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-card>

</template>

<script>
    import {formatDate} from "element-ui/src/utils/date-util";
    import TicketOnTimeStatistics from './ticketOnTimeStatistics'
    import TicketLevelNumStatistics from "@/views/board/boss/ticketProblemChange/ticketLevelNumStatistics";
    import ProblemCompletionRate from "@/views/board/boss/ticketProblemChange/problemCompletionRate"
    import ChangeLevelNumStatistics from "@/views/board/boss/ticketProblemChange/changeLevelNumStatistics"
    import ChangeDoneStatistics from "@/views/board/boss/ticketProblemChange/changeDoneStatistics"

    let that;

    export default {
        name: "ticketProblemChange",

        components: {
            TicketLevelNumStatistics,
            TicketOnTimeStatistics,
            ProblemCompletionRate,
            ChangeLevelNumStatistics,
            ChangeDoneStatistics
        },

        props: {
            dcnumids: {
                type: Array,
            },
            dcnumMap: null,
            searchDate: {
                type: String,
                default() {
                    return formatDate(new Date(), 'yyyy-MM');
                }
            },
        },

        async created() {
            that = this;
        },

        data() {
            return {

                activeName: 'first',

                tabKey: '',     //解决tab-pane中echarts宽度错误问题，TAB切换时，修改组件的Key，可以强制刷新组件

            }
        },

        methods: {
            handleTableClick(tab) {
                this.tabKey = tab;
            },
        },

        watch: {}

    }
</script>

<style scoped>

</style>